import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { tokenFromHash } from '../../lib/safe-next';

/**
 * Reads the single-use token from the URL fragment once, then replaces the history entry so the
 * token does not linger in browser history.
 */
export function useFragmentToken(): string | null {
  const location = useLocation();
  const navigate = useNavigate();
  const [token] = useState(() => tokenFromHash(location.hash));
  const { hash, pathname, search } = location;

  useEffect(() => {
    if (hash !== '') {
      void navigate({ pathname, search }, { replace: true });
    }
  }, [hash, pathname, search, navigate]);

  return token;
}
